<template>
  <v-container fluid>
    <v-row align="center">
      <v-col class="d-flex" cols="12" sm="12">
        <v-select
          label="IP Version"
          :items="list"
          :return-object="false"
        ></v-select>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: "Home",
  components: {},
  data() {
    return {
      ipversion: "",
      list: [1, 2, 3],
    };
  },
  computed: {
    ipversionlist() {
      return this.$store.state.IPVersion.ipversionlist;
    },
  },
};
</script>
